import request from '@/api/request'
import store from '@/store'

export function listRole(query) {
  return request({
    url: '/system/role/list',
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region,
    },
    params: query,
  })
}


